import { CreateContainer } from "./ContainerCreate";
import LoadMoreContainer from "./LoadMoreContainer";
import { getQuotesAll } from "../api/getQuotes";

const PER_PAGE = 30;

class QuotesContainer extends LoadMoreContainer {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: true, items: [] };
  }
  fetch = () => {
    const page = this.state.page;
    return this.props.request(page).then((response) => {
      this.fetching = false;
      const quotes = (response && response.data && response.data.quotes) || [];
      const hasMore = quotes.length === PER_PAGE;
      this.setState({ items: this.state.items.concat(quotes), page: page + 1, hasMore });
    });
  };
}

QuotesContainer.defaultProps = {};
export default CreateContainer(getQuotesAll, QuotesContainer);
